<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="height: 300px;">

        <el-form :model="editForm" :rules="rules" ref="editForm">

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="排班时间"  required prop="time">
                <el-date-picker
                    v-model="editForm.time"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    disabled
                    :picker-options="pickerOption"
                    style="width:100%">
                </el-date-picker>
              </el-form-item>
            </el-col>

          </el-row>

          <el-row v-if="isRemarks()">
            <el-col :span="24" class="item">
                <el-form-item label="备注" required prop="remarks">
                  <el-input v-model="editForm.remarks" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
                </el-form-item>
              </el-col>
          </el-row>

          <el-row>
            <el-col :span="24" class="item">
              <el-card class="box-card" shadow='never'>
                <div slot="header" class="clearfix">
                  <span>{{schedulName1}}</span>
                </div>
                <el-col :span="24" class="item">
                  <el-form-item label="早餐菜品"  required prop="nurseCodeArr1">
                    <el-select
                        v-model="editForm.nurseCodeArr1"
                        multiple
                        style="width:100%"
                        filterable
                        placeholder="请选择早晨菜品">
                      <el-option
                          v-for="item in dishesList"
                          :key="item.dishesCode"
                          :label="item.name"
                          :value="item.dishesCode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

              </el-card>
            </el-col>
          </el-row>

          <el-row style="margin-top: 10px;">
            <el-col :span="24" class="item">
              <el-card class="box-card" shadow='never'>
                <div slot="header" class="clearfix">
                  <span>{{schedulName2}}</span>
                </div>
                <el-col :span="24" class="item">
                  <el-form-item label="午餐菜品" required prop="nurseCodeArr2">
                    <el-select
                        v-model="editForm.nurseCodeArr2"
                        multiple
                        style="width:100%"
                        filterable
                        placeholder="请选择午餐菜品">
                      <el-option
                          v-for="item in dishesList"
                          :key="item.dishesCode"
                          :label="item.name"
                          :value="item.dishesCode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-card>
            </el-col>
          </el-row>

          <el-row style="margin-top: 10px;">
            <el-col :span="24" class="item">
              <el-card class="box-card" shadow='never'>
                <div slot="header" class="clearfix">
                  <span>{{schedulName3}}</span>
                </div>
                <el-col :span="24" class="item">
                  <el-form-item label="晚餐菜品"  required prop="nurseCodeArr3">
                    <el-select
                        v-model="editForm.nurseCodeArr3"
                        multiple
                        style="width:100%"
                        filterable
                        placeholder="请选择晚餐菜品">
                      <el-option
                          v-for="item in dishesList"
                          :key="item.dishesCode"
                          :label="item.name"
                          :value="item.dishesCode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-card>
            </el-col>
          </el-row>


        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
      </div>

    </div>
  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'Add',
  props:['dishesList'],
  data() {
    return {
      loading: false,

      schedulName1:'早餐',
      schedulName2:'午餐',
      schedulName3:'晚餐',


      editForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        time:'',
        status:0,

        dishesPlanCode:'',

        nurseCodeArr1:[],
        nurseCodeArr2:[],
        nurseCodeArr3:[],

        dishesPlan:{},

        remarks:'',

      },

      pickerOption: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },

      rules:{
        time:[
          { required: true, message: '请选择时间', trigger: 'blur' },
        ],

        nurseCodeArr1:[{ required: true, message: '请选择早晨菜品', trigger: 'blur' },
          { required: true, message: '请选择早晨菜品', trigger: 'change' }],
        nurseCodeArr2:[{ required: true, message: '请选择午餐菜品', trigger: 'blur' },
          { required: true, message: '请选择午餐菜品', trigger: 'change' }],
        nurseCodeArr3:[{ required: true, message: '请选择晚餐菜品', trigger: 'blur' },
          { required: true, message: '请选择晚餐菜品', trigger: 'change' }],

        remarks:[
          { required: true, message: '请填写备注', trigger: 'blur' },
        ],

      }

    }
  },

  methods: {
    init(row){
      this.loading = false;

      this.$refs.editForm.resetFields();

      this.editForm.time = row.time;
      this.editForm.dishesPlanCode = row.dishesPlanCode;

      var Morning=this.getNurseCode(row.dishesPlanMorningDTO.listDishesPlanMorningItem)
      this.editForm.nurseCodeArr1=Morning.list1
      var Noon=this.getNurseCode(row.dishesPlanNoonDTO.listDishesPlanNoonItem)
      this.editForm.nurseCodeArr2=Noon.list1
      var Night=this.getNurseCode(row.dishesPlanNightDTO.listDishesPlanNightItem)
      this.editForm.nurseCodeArr3=Night.list1

    },
    isRemarks(){
      if(this.editForm.time){
        var time=timefilters(this.editForm.time).slice(0,10)
        var nowTime=timefilters(new Date()).slice(0,10)
        if(time==nowTime){
          return true
        }
      }
      return false
    },

    getNurseCode(array){
      var listAll={list1:[]}
      for(var i in array){
        if(array[i].dishesCode){
          listAll.list1.push(array[i].dishesCode)
        }
      }
      return listAll
    },

    closeSelf() {
      this.$emit("closeEdit");
    },

    confirm(editForm){
      this.$refs[editForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.editForm.dishesPlan = {};
      this.editForm.dishesPlan.morningPlan = this.editForm.nurseCodeArr1;
      this.editForm.dishesPlan.noonPlan = this.editForm.nurseCodeArr2;
      this.editForm.dishesPlan.nightPlan = this.editForm.nurseCodeArr3;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"DishesPlan/Edit",
        data: this.editForm
      }).then((response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeEdit");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          })

    },


  }
}


</script>





<style lang="scss" scoped>


</style>
